import { OptionsApi } from '@core/swagger-client';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/on-demand')({
    loader: async ({ context }) => {
        const onDemand = context.queryClient.ensureQueryData(OptionsApi.webinars.getOnDemand({ refetchInterval: 60_000, staleTime: 60_000 }));
        await Promise.all([onDemand]);
        return {
            onDemand: await onDemand
        };
    }
});
